<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="save" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-active="isProductsByOrderModalVisible" :vm-title="$t('products.by_order')")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
    vm-col(v-if="isHMM" vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-select(:disabled="hasBranch()" :placeholder='$t("branches.branch_placeholder")' :danger="$v.form.branch_id.$invalid && $v.form.branch_id.$model" :danger-text="$t('validation.required', { attribute: $t('branches.branch') })" v-model="form.branch_id" :label='$t("branches.branch")')
          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in branches")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("orders.folio_placeholder")' :danger="$v.form.folio.$invalid && $v.form.folio.$model" :danger-text="folioValidationMessage" v-model="form.folio" :label='$t("orders.folio")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, numeric, requiredIf } from 'vuelidate/lib/validators'
import { createNamespacedHelpers, mapGetters as configMapGetters } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('LabelGroups')

export default {
  name: 'ModalLabelProductsByOrder',
  mixins: [ModalMixin1],
  validations () {
    return {
      form: {
        folio: {
          required,
          numeric
        },
        branch_id: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isProductsByOrderModalVisible', 'order', 'orderDetails', 'branches']),
    ...configMapGetters(['isHMM']),
    folioValidationMessage () {
      const attribute = this.$t('orders.folio')
      return this.form.folio
        ? this.$t('validation.numeric', { attribute })
        : this.$t('validation.required', { attribute })
    }
  },
  watch: {
    isProductsByOrderModalVisible (value) {
      if (value) {
        if (this.branches.length === 0) this.getBranches()
        if (!this.isHMM) this.form.branch_id = 1
        else if (this.hasBranch()) this.addBranch()
      }
    }
  },
  methods: {
    ...mapActions([
      'setProductsByOrderModalVisible',
      'getOrder',
      'validateProductsFromOrder',
      'getBranches'
    ]),
    close () {
      this.setProductsByOrderModalVisible(false)
    },
    save () {
      const payload = {
        order_folio: this.form.folio,
        branch_id: this.form.branch_id,
        branch_name: this.branches[this.form.branch_id - 1].name
      }
      this.getOrder(payload).then(() => {
        const details = this.orderDetails.map(item => {
          return {
            code: item.code,
            quantity: 1,
            products_by_label: item.quantity
          }
        })
        if (details.length) {
          this.validateProductsFromOrder({ convertedDetails: details })
        }
        this.setProductsByOrderModalVisible(false)
        this.form.folio = ''
      })
    }
  }
}
</script>
